import React from "react";
import {
  Stack,
  Typography,
  Button,
  Dialog,
  DialogContent,
} from "@mui/material";
import AlertProp from "@/@types/Alert";

const Alert = ({ children, alertData }: AlertProp) => {
  return (
    <Dialog open={true}>
      <DialogContent sx={{ ...alertData.containerSx }}>
        <Stack
          sx={{
            display: "flex",
            gap: "20px",
            minWidth: "400px",
            minHeight: "200px",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {alertData.message && (
            <Typography variant="h2">{alertData.message}</Typography>
          )}

          {children}

          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            gap="1rem"
            width="100%"
          >
            {alertData.button && (
              <Button variant="contained" onClick={alertData.button.method}>
                {alertData.button.text}
              </Button>
            )}
            {alertData.closeMethod && (
              <Button onClick={alertData.closeMethod} variant="outlined">
                close
              </Button>
            )}
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default Alert;
